<div class="odometer">
    <div *ngFor="let digit of digitArray" class="digit">
        {{ digit }}
    </div>
</div>